import { FC } from 'react';
import { SVG, SVGComponentProps } from '../Template';

export const DogBowl: FC<SVGComponentProps> = ({ pathProps, ...props }) => {
  return (
    <SVG {...props} stroke="none">
      <path
        d="M10 15.0004L15.586 9.4154C15.3534 9.18288 15.1817 8.89658 15.0862 8.58187C14.9907 8.26716 14.9743 7.93374 15.0384 7.61116C15.1025 7.28858 15.2451 6.98678 15.4537 6.7325C15.6623 6.47822 15.9304 6.27931 16.2342 6.15339C16.5381 6.02746 16.8683 5.9784 17.1956 6.01056C17.5229 6.04272 17.8372 6.1551 18.1107 6.33776C18.3842 6.52041 18.6085 6.76769 18.7636 7.05771C18.9187 7.34772 18.9999 7.67151 19 8.0004C19.329 8.00017 19.6529 8.08109 19.9432 8.23599C20.2334 8.39089 20.4809 8.61499 20.6638 8.88844C20.8467 9.16188 20.9593 9.47622 20.9917 9.80359C21.0241 10.131 20.9752 10.4613 20.8494 10.7653C20.7236 11.0692 20.5247 11.3375 20.2705 11.5462C20.0162 11.7549 19.7144 11.8977 19.3917 11.9619C19.0691 12.0261 18.7356 12.0098 18.4208 11.9143C18.106 11.8187 17.8196 11.6471 17.587 11.4144L14 15.0004"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M12.0014 13.0004L8.41543 9.4154C8.64802 9.18288 8.81969 8.89658 8.91521 8.58187C9.01073 8.26716 9.02717 7.93374 8.96307 7.61116C8.89897 7.28858 8.7563 6.98678 8.5477 6.7325C8.33911 6.47822 8.07103 6.27931 7.7672 6.15339C7.46337 6.02746 7.13318 5.9784 6.80586 6.01056C6.47855 6.04272 6.16421 6.1551 5.89071 6.33776C5.6172 6.52041 5.39295 6.76769 5.23784 7.05771C5.08272 7.34772 5.00152 7.67151 5.00143 8.0004C4.67245 8.00017 4.3485 8.08109 4.05827 8.23599C3.76805 8.39089 3.52052 8.61499 3.33761 8.88844C3.15471 9.16188 3.04208 9.47622 3.00971 9.80359C2.97733 10.131 3.02622 10.4613 3.15203 10.7653C3.27783 11.0692 3.47668 11.3375 3.73095 11.5462C3.98521 11.7549 4.28704 11.8977 4.60969 11.9619C4.93234 12.0261 5.26585 12.0098 5.58065 11.9143C5.89546 11.8187 6.18184 11.6471 6.41443 11.4144L10.0014 15.0004M3.00143 20.0004H21.0014C20.8264 18.3294 20.9554 16.6554 19.0014 15.0004H5.00143C3.66843 16.0004 3.00143 17.6674 3.00143 20.0004Z"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </SVG>
  );
};
export const RefreshCw02: FC<SVGComponentProps> = ({ pathProps, ...props }) => {
  return (
    <SVG {...props} stroke="none">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
      >
        <path
          d="M2 14C2 14 2.12132 14.8492 5.63604 18.364C9.15076 21.8787 14.8492 21.8787 18.364 18.364C19.6092 17.1187 20.4133 15.5993 20.7762 14M2 14V20M2 14H8M22 10C22 10 21.8787 9.15076 18.364 5.63604C14.8492 2.12132 9.15076 2.12132 5.63604 5.63604C4.39076 6.88131 3.58669 8.40072 3.22383 10M22 10V4M22 10H16"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </SVG>
  );
};

export const DotsHorizontal: FC<SVGComponentProps> = ({
  pathProps,
  ...props
}) => {
  return (
    <SVG {...props} stroke="none">
      <path
        d="M12 13C12.5523 13 13 12.5523 13 12C13 11.4477 12.5523 11 12 11C11.4477 11 11 11.4477 11 12C11 12.5523 11.4477 13 12 13Z"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
        {...pathProps}
      />
      <path
        d="M19 13C19.5523 13 20 12.5523 20 12C20 11.4477 19.5523 11 19 11C18.4477 11 18 11.4477 18 12C18 12.5523 18.4477 13 19 13Z"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
        {...pathProps}
      />
      <path
        d="M5 13C5.55228 13 6 12.5523 6 12C6 11.4477 5.55228 11 5 11C4.44772 11 4 11.4477 4 12C4 12.5523 4.44772 13 5 13Z"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
        {...pathProps}
      />
    </SVG>
  );
};
export const Bed: FC<SVGComponentProps> = ({ pathProps, ...props }) => {
  return (
    <SVG {...props} stroke="none" size="16" viewBox="0 0 16">
      <path
        d="M14.6654 11.3337V9.33366M14.6654 9.33366H1.33203M14.6654 9.33366H7.9987V6.00033H12.6654C13.1958 6.00033 13.7045 6.21104 14.0796 6.58611C14.4547 6.96118 14.6654 7.46989 14.6654 8.00033V9.33366ZM1.33203 5.33366V11.3337M3.33203 6.00033C3.33203 6.35395 3.47251 6.69309 3.72256 6.94313C3.9726 7.19318 4.31174 7.33366 4.66536 7.33366C5.01899 7.33366 5.35812 7.19318 5.60817 6.94313C5.85822 6.69309 5.9987 6.35395 5.9987 6.00033C5.9987 5.6467 5.85822 5.30756 5.60817 5.05752C5.35812 4.80747 5.01899 4.66699 4.66536 4.66699C4.31174 4.66699 3.9726 4.80747 3.72256 5.05752C3.47251 5.30756 3.33203 5.6467 3.33203 6.00033Z"
        stroke="currentColor"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SVG>
  );
};
export const Download01: FC<SVGComponentProps> = ({ pathProps, ...props }) => {
  return (
    <SVG {...props} stroke="none">
      <path
        d="M21 15V16.2C21 17.8802 21 18.7202 20.673 19.362C20.3854 19.9265 19.9265 20.3854 19.362 20.673C18.7202 21 17.8802 21 16.2 21H7.8C6.11984 21 5.27976 21 4.63803 20.673C4.07354 20.3854 3.6146 19.9265 3.32698 19.362C3 18.7202 3 17.8802 3 16.2V15M17 10L12 15M12 15L7 10M12 15V3"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </SVG>
  );
};

export const AtSign: FC<SVGComponentProps> = ({ ...props }) => {
  return (
    <SVG {...props} stroke="none">
      <path
        d="M16 7.99999V13C16 13.7956 16.3161 14.5587 16.8787 15.1213C17.4413 15.6839 18.2043 16 19 16C19.7956 16 20.5587 15.6839 21.1213 15.1213C21.6839 14.5587 22 13.7956 22 13V12C21.9999 9.74302 21.2362 7.55247 19.8333 5.78452C18.4303 4.01658 16.4705 2.77521 14.2726 2.26229C12.0747 1.74936 9.76793 1.99503 7.72734 2.95936C5.68676 3.92368 4.03239 5.54995 3.03325 7.57371C2.03411 9.59748 1.74896 11.8997 2.22416 14.1061C2.69936 16.3125 3.90697 18.2932 5.65062 19.7263C7.39428 21.1593 9.57143 21.9603 11.8281 21.9991C14.0847 22.0379 16.2881 21.3122 18.08 19.94M16 12C16 14.2091 14.2091 16 12 16C9.79086 16 8 14.2091 8 12C8 9.79085 9.79086 7.99999 12 7.99999C14.2091 7.99999 16 9.79085 16 12Z"
        stroke="black"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </SVG>
  );
};
export const Check: FC<SVGComponentProps> = ({ pathProps, ...props }) => {
  return (
    <SVG {...props} stroke="none">
      <path
        d="M20 6L9 17L4 12"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        {...pathProps}
      />
    </SVG>
  );
};
export const CheckWhite: FC<SVGComponentProps> = ({ ...props }) => {
  return (
    <SVG {...props} stroke="none">
      <path
        d="M11.6666 3.5L5.49994 9.66667L2.33327 6.5"
        stroke="white"
        stroke-width="1.6666"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </SVG>
  );
};
export const HomeLine: FC<SVGComponentProps> = ({ ...props }) => {
  return (
    <SVG {...props} stroke="none">
      <path
        d="M8 17H16M11.0177 2.764L4.23539 8.03912C3.78202 8.39175 3.55534 8.56806 3.39203 8.78886C3.24737 8.98444 3.1396 9.20478 3.07403 9.43905C3 9.70352 3 9.9907 3 10.5651V17.8C3 18.9201 3 19.4801 3.21799 19.908C3.40973 20.2843 3.71569 20.5903 4.09202 20.782C4.51984 21 5.07989 21 6.2 21H17.8C18.9201 21 19.4802 21 19.908 20.782C20.2843 20.5903 20.5903 20.2843 20.782 19.908C21 19.4801 21 18.9201 21 17.8V10.5651C21 9.9907 21 9.70352 20.926 9.43905C20.8604 9.20478 20.7526 8.98444 20.608 8.78886C20.4447 8.56806 20.218 8.39175 19.7646 8.03913L12.9823 2.764C12.631 2.49075 12.4553 2.35412 12.2613 2.3016C12.0902 2.25526 11.9098 2.25526 11.7387 2.3016C11.5447 2.35412 11.369 2.49075 11.0177 2.764Z"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </SVG>
  );
};
export const Eye: FC<SVGComponentProps> = ({ ...props }) => {
  return (
    <SVG {...props} stroke="none">
      <path
        d="M2.42012 12.7132C2.28394 12.4975 2.21584 12.3897 2.17772 12.2234C2.14909 12.0985 2.14909 11.9015 2.17772 11.7766C2.21584 11.6103 2.28394 11.5025 2.42012 11.2868C3.54553 9.50484 6.8954 5 12.0004 5C17.1054 5 20.4553 9.50484 21.5807 11.2868C21.7169 11.5025 21.785 11.6103 21.8231 11.7766C21.8517 11.9015 21.8517 12.0985 21.8231 12.2234C21.785 12.3897 21.7169 12.4975 21.5807 12.7132C20.4553 14.4952 17.1054 19 12.0004 19C6.8954 19 3.54553 14.4952 2.42012 12.7132Z"
        stroke="black"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M12.0004 15C13.6573 15 15.0004 13.6569 15.0004 12C15.0004 10.3431 13.6573 9 12.0004 9C10.3435 9 9.0004 10.3431 9.0004 12C9.0004 13.6569 10.3435 15 12.0004 15Z"
        stroke="black"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </SVG>
  );
};
export const EyeOff: FC<SVGComponentProps> = ({ ...props }) => {
  return (
    <SVG {...props} stroke="none">
      <path
        d="M10.7429 5.09232C11.1494 5.03223 11.5686 5 12.0004 5C17.1054 5 20.4553 9.50484 21.5807 11.2868C21.7169 11.5025 21.785 11.6103 21.8231 11.7767C21.8518 11.9016 21.8517 12.0987 21.8231 12.2236C21.7849 12.3899 21.7164 12.4985 21.5792 12.7156C21.2793 13.1901 20.8222 13.8571 20.2165 14.5805M6.72432 6.71504C4.56225 8.1817 3.09445 10.2194 2.42111 11.2853C2.28428 11.5019 2.21587 11.6102 2.17774 11.7765C2.1491 11.9014 2.14909 12.0984 2.17771 12.2234C2.21583 12.3897 2.28393 12.4975 2.42013 12.7132C3.54554 14.4952 6.89541 19 12.0004 19C14.0588 19 15.8319 18.2676 17.2888 17.2766M3.00042 3L21.0004 21M9.8791 9.87868C9.3362 10.4216 9.00042 11.1716 9.00042 12C9.00042 13.6569 10.3436 15 12.0004 15C12.8288 15 13.5788 14.6642 14.1217 14.1213"
        stroke="black"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </SVG>
  );
};

export const AlertCircleRed: FC<SVGComponentProps> = ({ ...props }) => {
  return (
    <SVG {...props} stroke="none">
      <g clip-path="url(#clip0_3531_403110)">
        <path
          d="M7.99992 5.33337V8.00004M7.99992 10.6667H8.00659M14.6666 8.00004C14.6666 11.6819 11.6818 14.6667 7.99992 14.6667C4.31802 14.6667 1.33325 11.6819 1.33325 8.00004C1.33325 4.31814 4.31802 1.33337 7.99992 1.33337C11.6818 1.33337 14.6666 4.31814 14.6666 8.00004Z"
          stroke="#F04438"
          stroke-width="1.33333"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_3531_403110">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </SVG>
  );
};
export const Close: FC<SVGComponentProps> = ({ pathProps, ...props }) => {
  return (
    <SVG {...props} stroke="none">
      <path
        d="M18 6L6 18M6 6L18 18"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        {...pathProps}
      />
    </SVG>
  );
};
export const InfoCircle: FC<SVGComponentProps> = ({ pathProps, ...props }) => {
  return (
    <SVG {...props} stroke="none">
      <path
        d="M12 16V12M12 8H12.01M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z"
        stroke="black"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
        {...pathProps}
      />
    </SVG>
  );
};
export const Edit02: FC<SVGComponentProps> = ({ pathProps, ...props }) => {
  return (
    <SVG {...props} stroke="none">
      <path
        d="M18 10L14 6M2.49997 21.5L5.88434 21.124C6.29783 21.078 6.50457 21.055 6.69782 20.9925C6.86926 20.937 7.03242 20.8586 7.18286 20.7594C7.35242 20.6475 7.49951 20.5005 7.7937 20.2063L21 7C22.1046 5.89543 22.1046 4.10457 21 3C19.8954 1.89543 18.1046 1.89543 17 3L3.7937 16.2063C3.49952 16.5005 3.35242 16.6475 3.24061 16.8171C3.1414 16.9676 3.06298 17.1307 3.00748 17.3022C2.94493 17.4954 2.92195 17.7021 2.87601 18.1156L2.49997 21.5Z"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        {...pathProps}
      />
    </SVG>
  );
};
export const Arena: FC<SVGComponentProps> = ({
  pathProps,
  stroke = "currentColor",
  strokeWidth = "1.6",
  ...props
}) => {
  const strokeColor = pathProps?.stroke ?? stroke;
  return (
    <SVG {...props} stroke={strokeColor} strokeWidth={strokeWidth} fill="none">
      <path
        d="M3 9v8c0 2.2 4 4 9 4s9-1.8 9-4V9M3 9V4l4 1.5L3 7m18 2V4l-4 1.5L21 7M8 13v6m8-6v6m-4-5v7"
        stroke={strokeColor}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
        {...pathProps}
      />
      <ellipse
        cx="12"
        cy="9"
        rx="9"
        ry="4"
        stroke={strokeColor}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <ellipse
        cx="12"
        cy="9"
        rx="5"
        ry="1.8"
        stroke={strokeColor}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </SVG>
  );
};
export const ArenaIcon = Arena;

export const Building05: FC<SVGComponentProps> = ({ pathProps, ...props }) => {
  return (
    <SVG {...props} stroke="none">
      <path
        d="M13 11H17.8C18.9201 11 19.4802 11 19.908 11.218C20.2843 11.4097 20.5903 11.7157 20.782 12.092C21 12.5198 21 13.0799 21 14.2V21M13 21V6.2C13 5.0799 13 4.51984 12.782 4.09202C12.5903 3.71569 12.2843 3.40973 11.908 3.21799C11.4802 3 10.9201 3 9.8 3H6.2C5.0799 3 4.51984 3 4.09202 3.21799C3.71569 3.40973 3.40973 3.71569 3.21799 4.09202C3 4.51984 3 5.0799 3 6.2V21M22 21H2M6.5 7H9.5M6.5 11H9.5M6.5 15H9.5"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        {...pathProps}
      />
    </SVG>
  );
};
export const Upload01: FC<SVGComponentProps> = ({ pathProps, ...props }) => {
  return (
    <SVG {...props} stroke="none">
      <path
        d="M21 15V16.2C21 17.8802 21 18.7202 20.673 19.362C20.3854 19.9265 19.9265 20.3854 19.362 20.673C18.7202 21 17.8802 21 16.2 21H7.8C6.11984 21 5.27976 21 4.63803 20.673C4.07354 20.3854 3.6146 19.9265 3.32698 19.362C3 18.7202 3 17.8802 3 16.2V15M17 8L12 3M12 3L7 8M12 3V15"
        stroke="black"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
        {...pathProps}
      />
    </SVG>
  );
};
export const SearchMD: FC<SVGComponentProps> = ({ pathProps, ...props }) => {
  return (
    <SVG {...props} stroke="none">
      <path
        d="M21 21L16.65 16.65M19 11C19 15.4183 15.4183 19 11 19C6.58172 19 3 15.4183 3 11C3 6.58172 6.58172 3 11 3C15.4183 3 19 6.58172 19 11Z"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
        {...pathProps}
      />
    </SVG>
  );
};
export const Logout01: FC<SVGComponentProps> = ({ pathProps, ...props }) => {
  return (
    <SVG {...props} stroke="none">
      <path
        d="M16 17L21 12M21 12L16 7M21 12H9M9 3H7.8C6.11984 3 5.27976 3 4.63803 3.32698C4.07354 3.6146 3.6146 4.07354 3.32698 4.63803C3 5.27976 3 6.11984 3 7.8V16.2C3 17.8802 3 18.7202 3.32698 19.362C3.6146 19.9265 4.07354 20.3854 4.63803 20.673C5.27976 21 6.11984 21 7.8 21H9"
        stroke="black"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
        {...pathProps}
      />
    </SVG>
  );
};
export const Trash02: FC<SVGComponentProps> = ({ pathProps, ...props }) => {
  return (
    <SVG {...props} stroke="none">
      <path
        d="M16 6V5.2C16 4.0799 16 3.51984 15.782 3.09202C15.5903 2.71569 15.2843 2.40973 14.908 2.21799C14.4802 2 13.9201 2 12.8 2H11.2C10.0799 2 9.51984 2 9.09202 2.21799C8.71569 2.40973 8.40973 2.71569 8.21799 3.09202C8 3.51984 8 4.0799 8 5.2V6M3 6H21M19 6V17.2C19 18.8802 19 19.7202 18.673 20.362C18.3854 20.9265 17.9265 21.3854 17.362 21.673C16.7202 22 15.8802 22 14.2 22H9.8C8.11984 22 7.27976 22 6.63803 21.673C6.07354 21.3854 5.6146 20.9265 5.32698 20.362C5 19.7202 5 18.8802 5 17.2V6"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
        {...pathProps}
      />
    </SVG>
  );
};
export const Plus: FC<SVGComponentProps> = ({ pathProps, ...props }) => {
  return (
    <SVG {...props} stroke="none">
      <path
        d="M12 5V19M5 12H19"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke="currentColor"
        {...pathProps}
      />
    </SVG>
  );
};
export const Minus: FC<SVGComponentProps> = ({ pathProps, ...props }) => {
  return (
    <SVG {...props} stroke="none">
      <path
        d="M5 12H19"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
        {...pathProps}
      />
    </SVG>
  );
};
export const Pool: FC<SVGComponentProps> = ({ pathProps, ...props }) => {
  return (
    <SVG {...props} stroke="none">
      <path
        d="M1.33203 13.3333C1.48348 13.5443 1.68401 13.7153 1.91631 13.8314C2.14862 13.9476 2.4057 14.0054 2.66536 14C2.92503 14.0054 3.18211 13.9476 3.41441 13.8314C3.64672 13.7153 3.84725 13.5443 3.9987 13.3333C4.15014 13.1223 4.35068 12.9514 4.58298 12.8352C4.81528 12.7191 5.07237 12.6612 5.33203 12.6667C5.5917 12.6612 5.84878 12.7191 6.08108 12.8352C6.31338 12.9514 6.51392 13.1223 6.66536 13.3333C6.81681 13.5443 7.01735 13.7153 7.24965 13.8314C7.48195 13.9476 7.73903 14.0054 7.9987 14C8.25836 14.0054 8.51545 13.9476 8.74775 13.8314C8.98005 13.7153 9.18058 13.5443 9.33203 13.3333C9.48348 13.1223 9.68401 12.9514 9.91631 12.8352C10.1486 12.7191 10.4057 12.6612 10.6654 12.6667C10.925 12.6612 11.1821 12.7191 11.4144 12.8352C11.6467 12.9514 11.8473 13.1223 11.9987 13.3333C12.1501 13.5443 12.3507 13.7153 12.583 13.8314C12.8153 13.9476 13.0724 14.0054 13.332 14C13.5917 14.0054 13.8488 13.9476 14.0811 13.8314C14.3134 13.7153 14.5139 13.5443 14.6654 13.3333M1.33203 10.6667C1.48348 10.8777 1.68401 11.0486 1.91631 11.1648C2.14862 11.2809 2.4057 11.3388 2.66536 11.3333C2.92503 11.3388 3.18211 11.2809 3.41441 11.1648C3.64672 11.0486 3.84725 10.8777 3.9987 10.6667C4.15014 10.4557 4.35068 10.2847 4.58298 10.1686C4.81528 10.0524 5.07237 9.99456 5.33203 10C5.5917 9.99456 5.84878 10.0524 6.08108 10.1686C6.31338 10.2847 6.51392 10.4557 6.66536 10.6667C6.81681 10.8777 7.01735 11.0486 7.24965 11.1648C7.48195 11.2809 7.73903 11.3388 7.9987 11.3333C8.25836 11.3388 8.51545 11.2809 8.74775 11.1648C8.98005 11.0486 9.18058 10.8777 9.33203 10.6667C9.48348 10.4557 9.68401 10.2847 9.91631 10.1686C10.1486 10.0524 10.4057 9.99456 10.6654 10C10.925 9.99456 11.1821 10.0524 11.4144 10.1686C11.6467 10.2847 11.8473 10.4557 11.9987 10.6667C12.1501 10.8777 12.3507 11.0486 12.583 11.1648C12.8153 11.2809 13.0724 11.3388 13.332 11.3333C13.5917 11.3388 13.8488 11.2809 14.0811 11.1648C14.3134 11.0486 14.5139 10.8777 14.6654 10.6667M9.9987 8V3C9.9987 2.73478 10.1041 2.48043 10.2916 2.29289C10.4791 2.10536 10.7335 2 10.9987 2C11.2639 2 11.5183 2.10536 11.7058 2.29289C11.8933 2.48043 11.9987 2.73478 11.9987 3M5.9987 8V3C5.9987 2.73478 5.89334 2.48043 5.7058 2.29289C5.51827 2.10536 5.26391 2 4.9987 2C4.73348 2 4.47913 2.10536 4.29159 2.29289C4.10405 2.48043 3.9987 2.73478 3.9987 3M9.9987 3.33333H5.9987M5.9987 6.66667H9.9987"
        stroke-width="1.2"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke="currentColor"
        {...pathProps}
      />
    </SVG>
  );
};
export const Gym: FC<SVGComponentProps> = ({ pathProps, ...props }) => {
  return (
    <SVG {...props} stroke="none">
      <path
        d="M4.93073 4.66699H3.06406C2.95798 4.66699 2.85623 4.70913 2.78122 4.78415C2.70621 4.85916 2.66406 4.96091 2.66406 5.06699V10.9337C2.66406 10.9862 2.67441 11.0382 2.69451 11.0867C2.71461 11.1353 2.74408 11.1794 2.78122 11.2165C2.81836 11.2536 2.86246 11.2831 2.91099 11.3032C2.95952 11.3233 3.01153 11.3337 3.06406 11.3337H4.93073C4.98326 11.3337 5.03527 11.3233 5.0838 11.3032C5.13233 11.2831 5.17643 11.2536 5.21357 11.2165C5.25072 11.1794 5.28018 11.1353 5.30028 11.0867C5.32038 11.0382 5.33073 10.9862 5.33073 10.9337V5.06699C5.33073 4.96091 5.28859 4.85916 5.21357 4.78415C5.13856 4.70913 5.03682 4.66699 4.93073 4.66699ZM12.9307 4.66699H11.0641C10.958 4.66699 10.8562 4.70913 10.7812 4.78415C10.7062 4.85916 10.6641 4.96091 10.6641 5.06699V10.9337C10.6641 10.9862 10.6744 11.0382 10.6945 11.0867C10.7146 11.1353 10.7441 11.1794 10.7812 11.2165C10.8184 11.2536 10.8625 11.2831 10.911 11.3032C10.9595 11.3233 11.0115 11.3337 11.0641 11.3337H12.9307C12.9833 11.3337 13.0353 11.3233 13.0838 11.3032C13.1323 11.2831 13.1764 11.2536 13.2136 11.2165C13.2507 11.1794 13.2802 11.1353 13.3003 11.0867C13.3204 11.0382 13.3307 10.9862 13.3307 10.9337V5.06699C13.3307 4.96091 13.2886 4.85916 13.2136 4.78415C13.1386 4.70913 13.0368 4.66699 12.9307 4.66699Z"
        stroke-width="1.2"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke="currentColor"
        {...pathProps}
      />
      <path
        d="M5.33073 8H10.6641M0.664062 9.6V6.4C0.664062 6.29391 0.706205 6.19217 0.78122 6.11716C0.856234 6.04214 0.957976 6 1.06406 6H2.26406C2.37015 6 2.47189 6.04214 2.54691 6.11716C2.62192 6.19217 2.66406 6.29391 2.66406 6.4V9.6C2.66406 9.70609 2.62192 9.80783 2.54691 9.88284C2.47189 9.95786 2.37015 10 2.26406 10H1.06406C0.957976 10 0.856234 9.95786 0.78122 9.88284C0.706205 9.80783 0.664062 9.70609 0.664062 9.6ZM15.3307 9.6V6.4C15.3307 6.29391 15.2886 6.19217 15.2136 6.11716C15.1386 6.04214 15.0368 6 14.9307 6H13.7307C13.6246 6 13.5229 6.04214 13.4479 6.11716C13.3729 6.19217 13.3307 6.29391 13.3307 6.4V9.6C13.3307 9.70609 13.3729 9.80783 13.4479 9.88284C13.5229 9.95786 13.6246 10 13.7307 10H14.9307C15.0368 10 15.1386 9.95786 15.2136 9.88284C15.2886 9.80783 15.3307 9.70609 15.3307 9.6Z"
        stroke-width="1.2"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke="currentColor"
        {...pathProps}
      />
    </SVG>
  );
};
export const Coffee: FC<SVGComponentProps> = ({ pathProps, ...props }) => {
  return (
    <SVG {...props} stroke="none">
      <path
        d="M11.3346 8H2.66797V10.6667C2.66797 11.3739 2.94892 12.0522 3.44902 12.5523C3.94911 13.0524 4.62739 13.3333 5.33464 13.3333H8.66797C9.37521 13.3333 10.0535 13.0524 10.5536 12.5523C11.0537 12.0522 11.3346 11.3739 11.3346 10.6667V8ZM11.3346 8H12.668C13.0216 8 13.3607 8.14048 13.6108 8.39052C13.8608 8.64057 14.0013 8.97971 14.0013 9.33333V10C14.0013 10.3536 13.8608 10.6928 13.6108 10.9428C13.3607 11.1929 13.0216 11.3333 12.668 11.3333H11.3346M8.66797 6C8.66797 6 9.33464 5.33333 9.0013 4.66667L8.33464 3.33333C8.0013 2.66667 8.66797 2 8.66797 2M5.7613 6C5.7613 6 6.42797 5.33333 6.09464 4.66667L5.42797 3.33333C5.09464 2.66667 5.7613 2 5.7613 2"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
        stroke="currentColor"
        {...pathProps}
      />
    </SVG>
  );
};

export const Menu04: FC<SVGComponentProps> = ({ pathProps, ...props }) => {
  return (
    <SVG {...props} stroke="none">
      <path
        d="M3 12H21M3 6H21M9 18H21"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
        {...pathProps}
      />
    </SVG>
  );
};
export const FilterFunnel01: FC<SVGComponentProps> = ({
  pathProps,
  ...props
}) => {
  return (
    <SVG {...props} stroke="none">
      <path
        d="M2 4.6C2 4.03995 2 3.75992 2.10899 3.54601C2.20487 3.35785 2.35785 3.20487 2.54601 3.10899C2.75992 3 3.03995 3 3.6 3H20.4C20.9601 3 21.2401 3 21.454 3.10899C21.6422 3.20487 21.7951 3.35785 21.891 3.54601C22 3.75992 22 4.03995 22 4.6V5.26939C22 5.53819 22 5.67259 21.9672 5.79756C21.938 5.90831 21.8901 6.01323 21.8255 6.10776C21.7526 6.21443 21.651 6.30245 21.4479 6.4785L15.0521 12.0215C14.849 12.1975 14.7474 12.2856 14.6745 12.3922C14.6099 12.4868 14.562 12.5917 14.5328 12.7024C14.5 12.8274 14.5 12.9618 14.5 13.2306V18.4584C14.5 18.6539 14.5 18.7517 14.4685 18.8363C14.4406 18.911 14.3953 18.9779 14.3363 19.0315C14.2695 19.0922 14.1787 19.1285 13.9971 19.2012L10.5971 20.5612C10.2296 20.7082 10.0458 20.7817 9.89827 20.751C9.76927 20.7242 9.65605 20.6476 9.58325 20.5377C9.5 20.4122 9.5 20.2142 9.5 19.8184V13.2306C9.5 12.9618 9.5 12.8274 9.46715 12.7024C9.43805 12.5917 9.39014 12.4868 9.32551 12.3922C9.25258 12.2856 9.15102 12.1975 8.94789 12.0215L2.55211 6.4785C2.34898 6.30245 2.24742 6.21443 2.17449 6.10776C2.10986 6.01323 2.06195 5.90831 2.03285 5.79756C2 5.67259 2 5.53819 2 5.26939V4.6Z"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </SVG>
  );
};

export const FilterLines: FC<SVGComponentProps> = ({ pathProps, ...props }) => {
  return (
    <SVG {...props} viewBox="0 0 20 20" stroke="none">
      <path
        d="M5 10H15M2.5 5H17.5M7.5 15H12.5"
        stroke="currentColor"
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
        {...pathProps}
      />
    </SVG>
  );
};

export const Share07: FC<SVGComponentProps> = ({ pathProps, ...props }) => {
  return (
    <SVG {...props} stroke="none">
      <path
        d="M8.59 13.51L15.42 17.49M15.41 6.51L8.59 10.49M21 5C21 6.65685 19.6569 8 18 8C16.3431 8 15 6.65685 15 5C15 3.34315 16.3431 2 18 2C19.6569 2 21 3.34315 21 5ZM9 12C9 13.6569 7.65685 15 6 15C4.34315 15 3 13.6569 3 12C3 10.3431 4.34315 9 6 9C7.65685 9 9 10.3431 9 12ZM21 19C21 20.6569 19.6569 22 18 22C16.3431 22 15 20.6569 15 19C15 17.3431 16.3431 16 18 16C19.6569 16 21 17.3431 21 19Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        {...pathProps}
      />
    </SVG>
  );
};
export const ShieldDollar: FC<SVGComponentProps> = ({
  pathProps,
  ...props
}) => {
  return (
    <SVG {...props} stroke="none">
      <path
        d="M9.21296 14.5004C9.52517 15.0949 10.1486 15.5004 10.8667 15.5004H13C14.1046 15.5004 15 14.6049 15 13.5004C15 12.3958 14.1046 11.5004 13 11.5004H11C9.89543 11.5004 9 10.6049 9 9.50036C9 8.39579 9.89543 7.50036 11 7.50036H13.1333C13.8514 7.50036 14.4748 7.90585 14.787 8.50036M12 6.00036V7.50036M12 15.5004V17.0004M20 12.0004C20 16.9088 14.646 20.4788 12.698 21.6152C12.4766 21.7444 12.3659 21.809 12.2097 21.8425C12.0884 21.8685 11.9116 21.8685 11.7903 21.8425C11.6341 21.809 11.5234 21.7444 11.302 21.6152C9.35396 20.4788 4 16.9088 4 12.0004V7.21796C4 6.41845 4 6.01869 4.13076 5.67506C4.24627 5.3715 4.43398 5.10064 4.67766 4.88589C4.9535 4.6428 5.3278 4.50243 6.0764 4.22171L11.4382 2.21103C11.6461 2.13307 11.75 2.09409 11.857 2.07864C11.9518 2.06493 12.0482 2.06493 12.143 2.07864C12.25 2.09409 12.3539 2.13307 12.5618 2.21103L17.9236 4.22171C18.6722 4.50243 19.0465 4.6428 19.3223 4.88589C19.566 5.10064 19.7537 5.3715 19.8692 5.67506C20 6.01869 20 6.41845 20 7.21796V12.0004Z"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
        {...pathProps}
      />
    </SVG>
  );
};

export const LinkExternal02: FC<SVGComponentProps> = ({
  pathProps,
  ...props
}) => {
  return (
    <SVG {...props} stroke="none">
      <path
        d="M21 9.00001L21 3.00001M21 3.00001H15M21 3.00001L12 12M10 3H7.8C6.11984 3 5.27976 3 4.63803 3.32698C4.07354 3.6146 3.6146 4.07354 3.32698 4.63803C3 5.27976 3 6.11984 3 7.8V16.2C3 17.8802 3 18.7202 3.32698 19.362C3.6146 19.9265 4.07354 20.3854 4.63803 20.673C5.27976 21 6.11984 21 7.8 21H16.2C17.8802 21 18.7202 21 19.362 20.673C19.9265 20.3854 20.3854 19.9265 20.673 19.362C21 18.7202 21 17.8802 21 16.2V14"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        {...pathProps}
      />
    </SVG>
  );
};

export const Copy05: FC<SVGComponentProps> = (props) => {
  return (
    <SVG {...props} stroke="none">
      <path
        d="M8 16V18.8C8 19.9201 8 20.4802 8.21799 20.908C8.40973 21.2843 8.71569 21.5903 9.09202 21.782C9.51984 22 10.0799 22 11.2 22H18.8C19.9201 22 20.4802 22 20.908 21.782C21.2843 21.5903 21.5903 21.2843 21.782 20.908C22 20.4802 22 19.9201 22 18.8V11.2C22 10.0799 22 9.51984 21.782 9.09202C21.5903 8.71569 21.2843 8.40973 20.908 8.21799C20.4802 8 19.9201 8 18.8 8H16M5.2 16H12.8C13.9201 16 14.4802 16 14.908 15.782C15.2843 15.5903 15.5903 15.2843 15.782 14.908C16 14.4802 16 13.9201 16 12.8V5.2C16 4.0799 16 3.51984 15.782 3.09202C15.5903 2.71569 15.2843 2.40973 14.908 2.21799C14.4802 2 13.9201 2 12.8 2H5.2C4.0799 2 3.51984 2 3.09202 2.21799C2.71569 2.40973 2.40973 2.71569 2.21799 3.09202C2 3.51984 2 4.07989 2 5.2V12.8C2 13.9201 2 14.4802 2.21799 14.908C2.40973 15.2843 2.71569 15.5903 3.09202 15.782C3.51984 16 4.07989 16 5.2 16Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SVG>
  );
};

export const Copy06: FC<SVGComponentProps> = ({ pathProps, ...props }) => {
  return (
    <SVG {...props} viewBox="0 0 20 20" stroke="none">
      <path
        d="M6.25 2.5H12.1667C14.0335 2.5 14.9669 2.5 15.68 2.86331C16.3072 3.18289 16.8171 3.69282 17.1367 4.32003C17.5 5.03307 17.5 5.96649 17.5 7.83333V13.75M5.16667 17.5H11.9167C12.8501 17.5 13.3168 17.5 13.6733 17.3183C13.9869 17.1586 14.2419 16.9036 14.4017 16.59C14.5833 16.2335 14.5833 15.7668 14.5833 14.8333V8.08333C14.5833 7.14991 14.5833 6.6832 14.4017 6.32668C14.2419 6.01308 13.9869 5.75811 13.6733 5.59832C13.3168 5.41667 12.8501 5.41667 11.9167 5.41667H5.16667C4.23325 5.41667 3.76654 5.41667 3.41002 5.59832C3.09641 5.75811 2.84144 6.01308 2.68166 6.32668C2.5 6.6832 2.5 7.14991 2.5 8.08333V14.8333C2.5 15.7668 2.5 16.2335 2.68166 16.59C2.84144 16.9036 3.09641 17.1586 3.41002 17.3183C3.76654 17.5 4.23325 17.5 5.16667 17.5Z"
        stroke="currentColor"
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
        {...pathProps}
      />
    </SVG>
  );
};

export const Copy01: FC<SVGComponentProps> = ({ pathProps, ...props }) => {
  return (
    <SVG {...props} stroke="none">
      <path
        d="M5 15C4.06812 15 3.60218 15 3.23463 14.8478C2.74458 14.6448 2.35523 14.2554 2.15224 13.7654C2 13.3978 2 12.9319 2 12V5.2C2 4.0799 2 3.51984 2.21799 3.09202C2.40973 2.71569 2.71569 2.40973 3.09202 2.21799C3.51984 2 4.0799 2 5.2 2H12C12.9319 2 13.3978 2 13.7654 2.15224C14.2554 2.35523 14.6448 2.74458 14.8478 3.23463C15 3.60218 15 4.06812 15 5M12.2 22H18.8C19.9201 22 20.4802 22 20.908 21.782C21.2843 21.5903 21.5903 21.2843 21.782 20.908C22 20.4802 22 19.9201 22 18.8V12.2C22 11.0799 22 10.5198 21.782 10.092C21.5903 9.71569 21.2843 9.40973 20.908 9.21799C20.4802 9 19.9201 9 18.8 9H12.2C11.0799 9 10.5198 9 10.092 9.21799C9.71569 9.40973 9.40973 9.71569 9.21799 10.092C9 10.5198 9 11.0799 9 12.2V18.8C9 19.9201 9 20.4802 9.21799 20.908C9.40973 21.2843 9.71569 21.5903 10.092 21.782C10.5198 22 11.0799 22 12.2 22Z"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
        {...pathProps}
      />
    </SVG>
  );
};

export const PlaneDeparture: FC<SVGComponentProps> = ({
  pathProps,
  ...props
}) => {
  return (
    <SVG {...props} stroke="none" viewBox="0 0 24 24">
      <path
        d="M2.9975 21.0002H20.9975M14.6365 10.2583L19.4665 8.96425C19.722 8.89047 19.9896 8.86837 20.2537 8.89925C20.5178 8.93013 20.7731 9.01336 21.0046 9.14408C21.2362 9.27481 21.4394 9.45039 21.6022 9.66056C21.7651 9.87073 21.8845 10.1113 21.9533 10.3681C22.0221 10.625 22.039 10.893 22.003 11.1564C21.967 11.4199 21.8789 11.6735 21.7437 11.9025C21.6085 12.1315 21.429 12.3312 21.2157 12.49C21.0024 12.6488 20.7596 12.7634 20.5015 12.8272L6.0125 16.7102L1.5625 11.6902L4.4595 10.9142L6.9095 12.3282L9.8065 11.5522L6.0635 5.30825L8.9615 4.53125L14.6365 10.2583Z"
        stroke="currentColor"
        stroke-width="1.8"
        stroke-linecap="round"
        stroke-linejoin="round"
        {...pathProps}
      />
    </SVG>
  );
};

export const PlaneArrival: FC<SVGComponentProps> = ({
  pathProps,
  ...props
}) => {
  return (
    <SVG {...props} stroke="none" viewBox="0 0 25 24">
      <path
        d="M3.5 20.9993H21.5M15.657 11.8093L20.487 13.1043C20.7443 13.169 20.9861 13.2842 21.1984 13.4433C21.4107 13.6024 21.5893 13.8021 21.7237 14.0308C21.8581 14.2595 21.9456 14.5127 21.9812 14.7756C22.0168 15.0384 21.9997 15.3058 21.931 15.562C21.8623 15.8182 21.7433 16.0582 21.5809 16.268C21.4186 16.4778 21.2161 16.6532 20.9853 16.784C20.7545 16.9148 20.5 16.9984 20.2366 17.0298C19.9732 17.0613 19.7061 17.0401 19.451 16.9673L4.962 13.0853L3.617 6.51333L6.515 7.28933L7.929 9.73933L10.827 10.5153L10.707 3.23633L13.605 4.01333L15.657 11.8093Z"
        stroke="currentColor"
        stroke-width="1.8"
        stroke-linecap="round"
        stroke-linejoin="round"
        {...pathProps}
      />
    </SVG>
  );
};

export const Networking01: FC<SVGComponentProps> = (props) => {
  return (
    <SVG {...props} stroke="none">
      <g clip-path="url(#clip0_2489_15630)">
        <mask
          id="mask0_2489_15630"
          style={{ maskType: 'luminance' }}
          maskUnits="userSpaceOnUse"
          x="-1"
          y="-1"
          width="81"
          height="81"
        >
          <path
            d="M79.9922 -0.00195312H-0.0078125V79.998H79.9922V-0.00195312Z"
            fill="white"
          />
        </mask>
        <g mask="url(#mask0_2489_15630)">
          <mask
            id="mask1_2489_15630"
            style={{ maskType: 'luminance' }}
            maskUnits="userSpaceOnUse"
            x="-1"
            y="-1"
            width="81"
            height="81"
          >
            <path
              d="M-0.0195312 -0.00585175H79.9805V79.9941H-0.0195312V-0.00585175Z"
              fill="white"
            />
          </mask>
          <g mask="url(#mask1_2489_15630)">
            <path
              d="M52.5039 15.6191C52.5039 22.5227 46.9077 28.1191 40.0039 28.1191C33.1003 28.1191 27.5039 22.5227 27.5039 15.6191C27.5039 8.71555 33.1003 3.11914 40.0039 3.11914C46.9077 3.11914 52.5039 8.71555 52.5039 15.6191Z"
              stroke="#667085"
              stroke-width="2.5"
              stroke-miterlimit="10"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M45.8223 76.8691H34.125"
              stroke="#667085"
              stroke-width="2.5"
              stroke-miterlimit="10"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M24.2852 34.9329C28.2042 30.7399 33.7842 28.119 39.9764 28.119C46.1717 28.119 51.7545 30.7426 55.6737 34.9395"
              stroke="#667085"
              stroke-width="2.5"
              stroke-miterlimit="10"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M73.9492 46.0293C73.9492 52.9329 68.3528 58.5293 61.4492 58.5293C54.5456 58.5293 48.9492 52.9329 48.9492 46.0293C48.9492 39.1257 54.5456 33.5293 61.4492 33.5293C68.3528 33.5293 73.9492 39.1257 73.9492 46.0293Z"
              stroke="#667085"
              stroke-width="2.5"
              stroke-miterlimit="10"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M45.8242 76.8691V74.1529C45.8242 65.5235 52.8197 58.5279 61.4492 58.5279C70.0787 58.5279 77.0742 65.5235 77.0742 74.1529V76.8691H45.8242Z"
              stroke="#667085"
              stroke-width="2.5"
              stroke-miterlimit="10"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M31.0803 46.1103C31.0803 53.0586 25.4475 58.6914 18.4991 58.6914C11.5508 58.6914 5.91797 53.0586 5.91797 46.1103C5.91797 39.1619 11.5508 33.5291 18.4991 33.5291C25.4475 33.5291 31.0803 39.1619 31.0803 46.1103Z"
              stroke="#667085"
              stroke-width="2.5"
              stroke-miterlimit="10"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M2.875 76.8691V74.1529C2.875 65.5235 9.87047 58.5279 18.5 58.5279C27.1295 58.5279 34.125 65.5235 34.125 74.1529V76.8691H2.875Z"
              stroke="#667085"
              stroke-width="2.5"
              stroke-miterlimit="10"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </g>
        </g>
      </g>
      <defs>
        <clipPath id="clip0_2489_15630">
          <rect width="80" height="80" fill="white" />
        </clipPath>
      </defs>
    </SVG>
  );
};
export const AgencyNotFound: FC<SVGComponentProps> = (props) => {
  return (
    <SVG {...props} stroke="none">
      <path
        d="M12.0391 58.9043H37.8203"
        stroke="#667085"
        stroke-width="2.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M12.0391 49.5293H38.5027"
        stroke="#667085"
        stroke-width="2.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M12.0391 68.2793H45.7841"
        stroke="#667085"
        stroke-width="2.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <mask
        id="mask0_6157_31852"
        style={{ maskType: 'luminance' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="80"
        height="80"
      >
        <path d="M0 0H80V80H0V0Z" fill="white" />
      </mask>
      <g mask="url(#mask0_6157_31852)">
        <path
          d="M33.125 16.7187C33.125 19.3075 31.0263 21.4062 28.4375 21.4062C25.8486 21.4062 23.75 19.3075 23.75 16.7187C23.75 14.13 25.8486 12.0312 28.4375 12.0312C31.0263 12.0312 33.125 14.13 33.125 16.7187Z"
          stroke="#667085"
          stroke-width="2.5"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M37.8125 35.4688H19.0625V33.125C19.0625 29.2417 22.2105 26.0937 26.0938 26.0937H30.7813C34.6645 26.0937 37.8125 29.2417 37.8125 33.125V35.4688Z"
          stroke="#667085"
          stroke-width="2.5"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M77.6548 77.6562L65.8125 65.8139"
          stroke="#667085"
          stroke-width="2.5"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M58.9063 49.5312L49.5312 58.9062"
          stroke="#667085"
          stroke-width="2.5"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M49.5312 49.5312L58.9063 58.9062"
          stroke="#667085"
          stroke-width="2.5"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M54.2188 70.625C45.1733 70.625 37.8125 63.2642 37.8125 54.2187C37.8125 45.1733 45.1733 37.8125 54.2188 37.8125C63.2642 37.8125 70.625 45.1733 70.625 54.2187C70.625 63.2642 63.2642 70.625 54.2188 70.625Z"
          stroke="#667085"
          stroke-width="2.5"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M54.2188 70.625V77.6562H2.34375V2.34375H54.2188V37.8125"
          stroke="#667085"
          stroke-width="2.5"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </g>
    </SVG>
  );
};

export const LinkIcon: FC<SVGComponentProps> = (props) => {
  return (
    <SVG {...props} stroke="none">
      <path
        d="M13.19 8.688a4.5 4.5 0 0 1 1.242 7.244l-4.5 4.5a4.5 4.5 0 0 1-6.364-6.364l1.757-1.757m13.35-.622 1.757-1.757a4.5 4.5 0 0 0-6.364-6.364l-4.5 4.5a4.5 4.5 0 0 0 1.242 7.244"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SVG>
  );
};
